import { Grid } from '@mui/material'
import { useCallback, useContext } from 'react'
import { Item } from 'src/ducks/types'
import { isEmpty } from 'src/helpers'
import { WorkOrdersContext } from '../../../../../context'
import Images from '../../../Images'

type ImageGalleryProps = {
  itemFromProps?: Item
}

const ImageGallery = ({ itemFromProps }: ImageGalleryProps) => {
  const {
    state: { item: itemFromContext, editItem },
    dispatch: dispatchContext,
  } = useContext(WorkOrdersContext)
  const item = itemFromProps || itemFromContext
  const isEditModal = !isEmpty(item.itemId)
  const imageFiles = editItem.imageFiles || item.imageFiles

  const submitAction = useCallback(
    (e: any) => {
      if (isEditModal) {
        dispatchContext({
          type: 'SET_EDIT_ITEM_VALUE',
          payload: { attr: 'imageFiles', value: e },
        })
      } else {
        dispatchContext({
          type: 'SET_ITEM_VALUE',
          payload: { attr: 'imageFiles', value: e },
        })
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isEditModal]
  )

  return (
    <Grid
      container
      sx={{
        flex: '1 1 auto',
        overflowY: 'auto',
        display: 'grid',
        padding: '0 1rem',
      }}
    >
      <Images
        downloadable
        initialTab={1}
        size="large"
        height="14rem"
        maximizeImage={false}
        deletable
        submitAction={submitAction}
        imageFiles={imageFiles}
        showCopyToItem
        hasTabs
      />
    </Grid>
  )
}

export default ImageGallery
